import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class CustomErrorHandlerService extends ErrorHandler {
    headers: any = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': '*/*' });
    constructor(private http: HttpClient) {
        super();
    }

    handleError(error) {
        // Here you can provide whatever logging you want
        super.handleError(error);
        let api_url = environment.baseUrl;
        this.http.post<any>(api_url + 'frontend_error', { error: String(error) != "[object Object]" ? String(error) : JSON.stringify(error), access_token: localStorage.getItem('token'), url: window.location.href }, { headers: this.headers })
            .subscribe(response => {
            });
    }
}